import { createFileRoute } from '@tanstack/react-router';
import { QuickstartRoute } from '../../../quickstart/quickstart-page.tsx';

export const Route = createFileRoute('/primeiros-passos/')({
  component: QuickstartRoute,
});
